export default __webpack_public_path__ + "static/media/brush-2.8c33990f.jpg";